import { Draggable } from "react-beautiful-dnd";
import { TileItem, ITileItem } from "components/feed/TileItem";
import { clsx } from "clsx";
import "./DraggableTile.scss";

interface IDraggableTile {
  gifId: string;
  tileItemProps: ITileItem;
  isDragDisabled: boolean;
}

export const DraggableTile: React.FC<IDraggableTile> = ({
  tileItemProps,
  isDragDisabled,
  gifId
}) => {
  return (
    <Draggable draggableId={gifId} index={tileItemProps.index} isDragDisabled={isDragDisabled}>
      {(provided, snapshot) => (
        <div
          ref={provided.innerRef}
          {...provided.draggableProps}
          {...provided.dragHandleProps}
          className={clsx("DraggableTile", snapshot.isDragging && "DraggableTile_isDragging")}
        >
          <TileItem
            {...tileItemProps}
          />
        </div>
      )}
    </Draggable>
  );
};
